import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class SamService {


  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = environment.basePath + '/user/sam';

  constructor(
    private _http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async addRead(codeSam: string, patientId: string): Promise<void> {
    try {
      const res = await this._http.post(this.apiUri, {idSam: codeSam, idPatient: patientId}, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async isRead(codeSam: string, patientId: string): Promise<{isSamRead: boolean}> {
    try {
      const res = await this._http.get(this.apiUri + '/isRead/' + codeSam + '/' + patientId, this.httpOptions).toPromise();
      const isRead = res.body as {isSamRead: boolean};
      return isRead;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async notRead(codeSam: string, patientId: string) {
    try {
      const res = await this._http.delete(this.apiUri + '/isRead/' + codeSam + '/' + patientId, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
